import { render, staticRenderFns } from "./NonInti.vue?vue&type=template&id=a608c9b8&"
import script from "./NonInti.vue?vue&type=script&lang=js&"
export * from "./NonInti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports